import "./sentry";
import Dropdown from "./dropdown";
import NagBanner from "./nag-banner";
import Modal from "./modal";
import "./sidebar";
import "./find-order";
import "./stock-check";
import "./mouser-sample-stock";
import RohsAutocomplete from "./rohs-search";
import PricebookAutocomplete from "./pricebook-search";
import "./perpage"
import nipAutocomplete from "./nip-search";
import "./image-gallery"
import "./customer-password-rules"
import passwordRuleCheck from "./customer-password-rules";
import notificationForm from "./notification-form";
import './waf-hacks'
import './data-layer-events';
import "./sticky-element";
import "./customer-application";
import "./profile-menu";
import "./basic-dialog";
import "./nag-dialog";
import "./truncated-table";
import "./expandable-order-table";
import "./registration-form-debounce";
import "./jump-to";
import "./corporation-check";
import "./autocomplete-select";
import "./corporation-sold-to-combo";
import "./notification-banner.js";
import "./alert-on-email-change";
import "./auto-submit";

const nagBanners: NagBanner[] = [];
const dropdowns: Dropdown[] = [];
const modals: Modal[] = [];

Array.prototype.forEach.call(
    document.querySelectorAll('.has-children'),
    function (element) {
        dropdowns.push(new Dropdown(element));
    }
);

Array.prototype.forEach.call(
    document.querySelectorAll('.nag-banner'),
    function (element) {
        nagBanners.push(new NagBanner(element));
    }
)

Array.prototype.forEach.call(
    document.querySelectorAll('[data-modal]'),
    function (element) {
        modals.push(new Modal(element));
    }
)

if (document.getElementById('rohs-search')) {
    new RohsAutocomplete();
}

if (document.getElementById('pricebook-search')) {
    new PricebookAutocomplete();
}

if (document.getElementById('npi-search')) {
    new nipAutocomplete();
}

if (document.getElementById('password-validation-container')) {
    new passwordRuleCheck();
}

if (document.getElementById('notification-preferences-form')) {
    new notificationForm();
}


// This is a workaround for Chrome allowing "dialog" elements to be
// dismissed by mashing the Escape key even if we're inhibiting the
// dialog's "cancel" event. For more information, see
// <https://issues.chromium.org/issues/346597066>.
document.addEventListener(
    "keydown",
    (event) => {
        if (document.querySelector("nag-dialog[no-close] dialog[open]") === null) {
            return;
        }

        if (event.key === "Escape") {
            event.preventDefault();
            event.stopPropagation();
        }
    },
);

